<organ-dynamic-tab-layout [tabs]="tabs"></organ-dynamic-tab-layout>
